module.exports = __webpack_public_path__ + "static/media/ubahn-o-echtzeit.84de9467.svg";